<template>
  <div>
    <h2 class="sui-header" id="requestHeader">ファイル引取アップロード</h2>
    <div id="upload" class="ui form">
      <div class="field">
        <label class="required">ファイル選択</label>
        <file-dropper id="file-dropper" @on-drop-file="onDrop"></file-dropper>
      </div>

      <table id="upload-table" class="ui table" v-if="files.length">
        <thead>
          <tr class="single line">
            <th width="30px">No.</th>
            <th>ファイル名</th>
            <th>ファイルサイズ</th>
            <th width="100px">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(file, index) in files" :key="index">
            <td class="Upload-fileTable__no">{{index + 1 }}</td>
            <td class="Upload-fileTable__fileName newline-wrap">{{file.name}}</td>
            <td class="Upload-fileTable__fileSize">{{file.size | bytes}}</td>
            <td class="Upload-fileTable__operation">
              <button
                class="ui button orange tiny Upload-fileTable__delete"
                @click="removeSelectedFile(index)"
              >
                削除
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="error" v-if="isFileSizeLimit">
      アップロードできるファイルサイズは合計1GiBまでです
      </div>
      <div class="error" v-if="isFileNumLimit && files.length > 0">
        同時にアップロード可能なファイル数は10ファイルです
      </div>

      <div class="field" v-bind:class="{'error': $v.unsigned_comments.$invalid }">
        <label>送信者からのコメント</label>
        <textarea
          id="Upload-unsignedTextarea"
          v-model="unsigned_comments"
          @blur="$v.unsigned_comments.$touch()"
          @focus="$v.unsigned_comments.$reset()"
        >
        </textarea>
      </div>
      <div
        class="error"
        v-if="$v.unsigned_comments.$invalid && !$v.unsigned_comments.maxLength"
      >
        コメントの長さは200文字までです
      </div>

      <div class="center-content">
        <button
          id="Upload-uploadButton"
          class="ui button green wide"
          @click="upload"
          :class="{ disabled: $v.$invalid || isUploadLimit }"
        >
          アップロード
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import FileDropper from '@/components/FileDropper.vue'
import { helpers } from 'vuelidate/lib/validators'
import _ from 'lodash'
import { uploadTransferFiles } from '@/api'
import { ERROR_MESSAGE } from '@/common'

/** 合計ファイルサイズ */
const maxFileSize = 1024 * 1024 * 1024

export default {
  title: 'ファイル引取アップロード',
  components: {
    FileDropper
  },
  data: function () {
    return {
      files: [],
      unsigned_comments: ''
    }
  },
  validations: {
    unsigned_comments: {
      maxLength: value => helpers.len(value) <= 200
    }
  },
  methods: {
    onDrop: function (files, containsDirectory) {
      let errorMessages = []

      let duplicate = false
      for (let file of files) {
        if (this.files.some(f => f.name === file.name)) {
          duplicate = true
        } else {
          this.files.push(file)
        }
      }

      if (duplicate) {
        errorMessages.push(ERROR_MESSAGE.DUPLICATE_FILENAME)
      }
      if (containsDirectory) {
        errorMessages.push(ERROR_MESSAGE.CONTAINS_DIRECTORY)
      }

      if (errorMessages.length > 0) {
        this.$store.commit('infoModal/openModal', {
          type: 'ERROR',
          title: 'ファイル選択',
          message: errorMessages
        })
      }
    },
    upload: function () {
      const self = this
      self.$store.commit('confirmModal/openModal', {
        title: 'ファイルアップロード',
        message: 'ファイルをアップロードします。\nよろしいですか？',
        executeLabel: 'アップロード',
        callback: function (answer) {
          if (answer) {
            self.$store.commit('progress/setLoading', true)
            let exchangeId = localStorage.getItem('exchange_id')
            if (exchangeId) {
              uploadTransferFiles(
                exchangeId,
                self.files,
                self.unsigned_comments
              )
                .then(() => {
                  localStorage.setItem('status', 'isUploaded')
                  self.$store.commit('progress/setLoading', false)
                  self.$router.push({ name: 'uploadComplete' })
                })
                .catch(error => {
                  console.log(error)
                  self.$store.commit('progress/setLoading', false)
                  self.$store.commit('infoModal/openModal', {
                    type: 'ERROR',
                    title: 'ファイルアップロード',
                    message:
                      '通信エラーが発生しました。\nしばらくしてからもう一度お試しください。'
                  })
                  localStorage.removeItem('role')
                })
            } else {
              self.$store.commit('progress/setLoading', false)
              self.$store.commit('infoModal/openModal', {
                type: 'ERROR',
                title: 'ファイルアップロード',
                message:
                  '通信エラーが発生しました。\nしばらくしてからもう一度お試しください。'
              })
              localStorage.removeItem('role')
            }
          }
        }
      })
    },
    removeSelectedFile: function (index) {
      this.files.splice(index, 1)
    }
  },
  computed: {
    isUploadLimit: function () {
      return this.isFileSizeLimit || this.isFileNumLimit
    },
    isFileSizeLimit: function () {
      const allSize = _.reduce(_.map(this.files, function (file) {
        return file.size
      }), function (sum, size) {
        return sum + size
      }, 0)
      return allSize > maxFileSize
    },
    isFileNumLimit: function () {
      return this.files.length <= 0 || this.files.length > 10
    }
  }
}
</script>
<style>
div#upload {
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}

.ui.button.wide {
  width: 400px;
  margin-top: 20px;
  font-size: large;
}

h2#requestHeader {
  max-width: 600px;
  margin: auto;
  margin-bottom: 20px;
}
</style>
